import React from 'react';
import { Search, Edit, Trash2, Clock } from 'lucide-react';

const ServiceList = ({
  services,
  searchTerm,
  setSearchTerm,
  isLoading,
  handleEditService,
  handleDeleteService,
}) => {
  const iconProps = { className: 'h-4 w-4' };

  return (
    <div className="bg-secondary-main mt-5 rounded shadow">
      <div className="flex flex-col justify-between gap-4 p-4 md:flex-row">
        <div>
          <h2 className="text-lg font-semibold">Servicios Registrados ({services.length})</h2>
        </div>
        <div className="relative w-full md:w-64">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            className="focus:ring-primary-main w-full rounded border border-gray-300 bg-black py-2 pl-10 pr-3 text-white focus:outline-none focus:ring-2"
            placeholder="Buscar por nombre o modalidad..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="flex flex-col gap-4 overflow-y-auto p-4">
        {isLoading ? (
          <p className="py-8 text-center text-gray-400">Cargando servicios...</p>
        ) : services.length > 0 ? (
          services.map((service) => (
            <div
              key={service._id}
              className="bg-secondary-dark border-primary-active gap-4 rounded border p-4 shadow max-sm:flex-col max-sm:gap-3 sm:flex sm:items-center sm:justify-between"
            >
              <div className="flex-1 min-w-[200px]">
                <h3 className="text-md font-semibold">{service.name}</h3>
                <p className="text-sm text-gray-300">
                  {service.fk_modality.name} ({service.fk_modality.dicom_code})
                </p>
              </div>

              <div className="flex flex-col sm:flex-row sm:gap-4 items-start sm:items-center flex-1 min-w-[400px]">
                <span className={`rounded px-2 py-1 text-xs uppercase text-white font-bold ${service.status ? 'bg-green-600' : 'bg-red-600'}`}>
                  {service.status ? 'Activo' : 'Inactivo'}
                </span>

                <p className="text-xs text-gray-400">Sucursal: **{service.fk_branch.short_name}**</p>

                <p className="text-xs text-gray-400 flex items-center gap-1">
                  <Clock className="h-3 w-3" /> {service.calendar_settings?.default_duration_min} min
                </p>

                <p className="text-xs text-gray-400">Equipos: {service.fk_equipments.length}</p>

                <div className="flex gap-2 mt-2 sm:mt-0">
                  <button
                    onClick={() => handleEditService(service)}
                    className="text-blue-300 hover:text-blue-600 p-1"
                    title="Editar servicio"
                  >
                    <Edit {...iconProps} />
                  </button>
                  <button
                    onClick={() => handleDeleteService(service._id)}
                    className="text-red-300 hover:text-red-800 p-1"
                    title="Eliminar servicio"
                  >
                    <Trash2 {...iconProps} />
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="py-8 text-center text-gray-400">No se encontraron servicios registrados.</p>
        )}
      </div>
    </div>
  );
};

export default ServiceList;
